import axios from "axios";
import store from "@/store";
import enurl from "@/api/environment";
const GlobalMixin = {
  data() {
    return {
      url: enurl.apiUrl,
      cur_lang: "en",
      ip: null,
      applicationName: "Seed product admin"
    };
  },
  methods: {
    itemsData(checkdata) {
      return [
        {
          action: "mdi-home-varitant-outline",
          items: [
            {
              title: "library",
              href: "/defaultcontent"
            }
          ],
          title: "defaultcontent"
        }
      ];
    },
    //** validate company management fields */
    validation_company_management() {
      let self = this;
      let cond = null;
      if (
        self.companyName &&
        self.abbreviation &&
        self.telephoneNumber &&
        self.email &&
        self.countryName &&
        self.cityName &&
        self.address &&
        //self.pricePlan &&
        //self.userID &&
        self.contactName &&
        self.packageName &&
        // self.paymentStatus&&
        //    self.saleName&&
        //     self.sellingPrice&&
        //       self.startdatesale&&
        //      self.purchasePeriod&&
        self.activeEmployee &&
        self.numberOfFile &&
        self.password &&
        self.userName
      ) {
        cond = true;
      } else {
        cond = false;
      }
      return cond;
    },
    validation_company_management1() {
      let self = this;
      let cond = null;
      console.log("companyName:", self.companyName);
      console.log("abbreviation:", self.abbreviation);
      console.log("telephoneNumber:", self.telephoneNumber);
      console.log("email:", self.email);
      console.log("countryName:", self.countryName);
      console.log("cityName:", self.cityName);
      console.log("address:", self.address);
      console.log("contactName:", self.contactName);
      console.log("packageName:", self.packageName);
      console.log("activeEmployee:", self.activeEmployee);
      console.log("numberOfFile:", self.numberOfFile);
      console.log("userName:", self.userName);
      if (
        self.companyName &&
        self.abbreviation &&
        self.telephoneNumber &&
        self.email &&
        self.countryName &&
        self.cityName &&
        self.address &&
        // self.pricePlan &&
        self.contactName &&
        //    self.paymentStatus&&
        //     self.saleName&&
        //      self.sellingPrice&&
        //      self.startdatesale&&
        //      self.purchasePeriod&&
        self.packageName &&
        self.activeEmployee &&
        self.numberOfFile &&
        //self.password2 &&
        self.userName
      ) {
        cond = true;
      } else {
        cond = false;
      }
      console.log("Validation result (cond):", cond);
      return cond;
    },
    validation_company_managementinformationweb() {
      let self = this;
      let cond = null;
      if (
        self.companyName &&
        self.abbreviation &&
        self.telephoneNumber &&
        self.email &&
        self.countryName &&
        self.cityName &&
        self.address &&
        self.contactName
      ) {
        cond = true;
      } else {
        cond = false;
      }
      return cond;
    },
    //** validate user management fields for Add*/
    validation_user_management() {
      let self = this;
      let cond = null;
      if (
        // self.empID &&   //can be save in blank
        self.empName &&
        self.email &&
        self.position &&
        self.role &&
        self.userID &&
        self.password
      ) {
        cond = true;
      } else {
        cond = false;
      }
      return cond;
    },
    //** validate user management fields for Edit*/
    validation_user_management1() {
      let self = this;
      let cond = null;
      if (
        // self.empID &&   //can be save in blank
        self.empName &&
        self.email &&
        self.position &&
        self.role &&
        self.userID
      ) {
        cond = true;
      } else {
        cond = false;
      }
      return cond;
    },

    //** get ip */
    async getIp() {
      let self = this;
      await fetch("https://api.ipify.org?format=json")
        .then(x => x.json())
        .then(({ ip }) => {
          self.ip = ip;
        });
    },

    //** add log */
    async add_log(ph, des, l_type, m_name, exc, l_trace, cor_id) {
      let self = this;
      await self.getIp();
      let temp = {
        userName: store.getters.fullName,
        userId: store.getters.userid,
        ip: self.ip,
        phoneModel: ph,
        description: des,
        logType: l_type,
        methodName: m_name,
        exception: exc,
        logTrace: l_trace,
        correctionID: cor_id,
        companyID: store.getters.companyid,
        applicationName: self.applicationName
      };
      axios.post(`${self.url}AppLog/AddAppLog`, temp).then(res => {
        if (l_type == "Critical") {
          alert(
            `CorrelationID: ${res.data.data.correctionID}\n LogID: ${res.data.data.logId}`
          );
          console.log(res);
        }
      });
    }
  },
  mounted() {
    let self = this;
  }
};

export default GlobalMixin;
